import { DataContext } from "../../helper/HelperOne"
import NavBar from "../nav_bar/Navbar"
import { useState } from "react"
import DeliveryNoteList from "./DeliveryNoteList"

const DeliveryNote = () => {
    const [searchUi, setSearchUi] = useState(true)
    const [searchData, setSearchData] = useState(null)
    return (
        <DataContext.Provider value={{ searchUi, setSearchUi, searchData, setSearchData }}>
            <NavBar
                childrenPage={<DeliveryNoteList />}
                menuId={28}
            />
        </DataContext.Provider>
    )
}

export default DeliveryNote